export default {
  data: () => ({
    translations: {
      createLoyaltyProgram: {
        el: 'Προσθήκη προγράμματος πιστότητας',
        en: 'Add Loyalty Program',
        it: 'Aggiungi programma fedeltà',
      },
      name: {
        el: 'Όνομα',
        en: 'Name',
        it: 'Nome',
      },
      description: {
        el: 'Περιγραφή',
        en: 'Description',
        it: 'Descrizione',
      },
      pointsLabel: {
        el: 'Ετικέτα πόντων',
        en: 'Points Label',
        it: 'Etichetta punti',
      },
      cashbackLabel: {
        el: 'Ετικέτα επιστροφής χρημάτων',
        en: 'Cashback Label',
        it: 'Etichetta cashback',
      },
      active: {
        el: 'Ενεργό',
        en: 'Active',
        it: 'Attivo',
      },
      actions: {
        el: 'Ενέργειες',
        en: 'Actions',
        it: 'Azioni',
      },
      update: {
        el: 'Ενημέρωση',
        en: 'Update',
        it: 'aggiornamento',
      },

      edit: {
        el: 'Επεξεργασία',
        en: 'Edit',
        it: 'Modifica',
      },
      delete: {
        el: 'Διαγραφή',
        en: 'Delete',
        it: 'Cancellare',
      },
      updateLoyaltyProgram: {
        el: 'Επεξεργασία προγράμματος πιστότητας',
        en: 'Edit Loyalty Program',
        it: 'Modifica programma fedeltà',
      },
      deleteLoyaltyProgram: {
        el: 'Διαγραφή προγράμματος πιστότητας',
        en: 'Delete Loyalty Program',
        it: 'Cancellare programma fedeltà',
      },
      deleteModalText: {
        el: 'Είστε σίγουροι ότι θέλετε να διαγράψετε το πρόγραμμα ',
        en: 'Are you sure you want to delete ',
        it: 'Sei sicuro di voler eliminare ',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
      activateOnCreate: {
        el: 'Ενεργοποίηση του προγράμματος κατά την δημιουργία',
        en: 'Activate loyalty program on creation',
        it: 'Attivazione del programma durante la creazione',
      },

      checkForm: {
        el: 'Μη έγκυρα δεδομένα φόρμας. Ελέγξτε τη φόρμα για πιθανά σφάλματα.',
        en: 'Invalid form data. Please, check the form for possible errors.',
        it: 'Dati del modulo non validi. Verificare la presenza di eventuali errori nel modulo.',
      },

      country: {
        el: 'Χώρα',
        en: 'Country',
        it: 'Paese',
      },
    },
  }),
};
